<template>
  <div :class="$style.container">
    <div :class="$style.header">
      Network
    </div>
    <div :class="$style.main">
      <ul :class="$style.infoList">
        <li :class="$style.infoListItem">
          <span>Hostname</span>
          <span>{{ item.hostname || '' }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>Primary Adapter IP</span>
          <span>{{ getSystemNIC(item) || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>Remote IP</span>
          <span>{{ item.remoteIP || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>{{ networkAdapterInterface }} MAC Address</span>
          <span>{{ networkAdapterMACAddress }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Constants, { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import SystemInsightsMetadata from 'client/systems/systemInsights/SystemInsightsMetadata';

import SystemInsightsComponentMixin from '../mixins/SystemInsightsComponentMixin';

const systemInsightsModule = StoreModuleMap[ItemTypeConsts.systemInsights];

const { metricGroups } = SystemInsightsMetadata;
const { unknown } = Constants;

export default {
  name: 'NetworkInsights',

  mixins: [SystemInsightsComponentMixin],

  data: () => ({
    unknown,
    networkAdapterInterface: 'Interface',
    networkAdapterMACAddress: unknown,
  }),

  computed: {
    ...mapGetters('SystemCollection', {
      getSystemNIC: 'getSystemNIC',
    }),
  },

  created() {
    this.getNetworkAdapterMACAddress();
  },

  methods: {
    ...mapActions(systemInsightsModule, [
      'fetchInsightsData',
    ]),

    /**
     * Finds an appropriate interface MAC address to show in the network insights section.
     * Uses the following business rules:
     * 1- If the 'en0' interface exists and the mac address is valid. Show this interface value.
     * 2- If the 'en0' interface is not found, show the first valid interface mac address found.
     * A valid MAC address is not empty and is not zero filled (00:00:00:00:00:00).
     */
    getNetworkAdapterMACAddress() {
      // looks for 'en0' interface index or first valid interface from the list
      const findInterfaceIndex = (interfaceList) => {
        const emptyMAC = '00:00:00:00:00:00';
        const isValidMacAddress = macAddress => (macAddress && !(macAddress === emptyMAC));

        const mainInterfaceIndex = interfaceList.findIndex(
          networkInterface => (networkInterface.interface === 'en0' && isValidMacAddress(networkInterface.mac)),
        );
        if (mainInterfaceIndex > -1) return mainInterfaceIndex;

        return interfaceList.findIndex(
          networkInterface => isValidMacAddress(networkInterface.mac),
        );
      };

      this.fetchInsightsData({
        id: this.item.id,
        metricGroup: metricGroups.interfaceDetails,
      })
        .then((data) => {
          const validInterfaceIndex = findInterfaceIndex(data);
          if (validInterfaceIndex > -1) {
            this.networkAdapterMACAddress = data ? data[validInterfaceIndex].mac : unknown;
            this.networkAdapterInterface = data ? data[validInterfaceIndex].interface : 'Interface';
          }
        })
        .catch(() => {
          this.networkAdapterMACAddress = unknown;
        });
    },
  },
};
</script>

<style module>
@import '../css/systemInsights.css';
</style>
